import { ampli } from "@/ampli"
import { Text, Button } from "@/elements"
import { useState } from "react"
import { Triangle } from "react-feather"
import { LockClosedIcon } from "@heroicons/react/24/outline"
import Link from "next/link"

interface Props {
  privateUsersLength: number
}

export const PrivateUsersCard: React.FC<Props> = ({ privateUsersLength }) => {
  const [isHovering, setIsHovering] = useState(false)

  const handleSignupClick = () => {}

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}>
      <div className="relative flex w-full items-center gap-2 rounded-full bg-bg-1">
        <Text className="text-fg-2" variant="body3">
          +{privateUsersLength} Private {privateUsersLength === 1 ? "Creative" : "Creatives"}
        </Text>
        <LockClosedIcon className="size-[18px] stroke-fg-2" />
      </div>
      {isHovering && (
        <div className="absolute bottom-full left-0 z-30 hidden w-[232px] transform pb-2 sm:block">
          <div
            className="relative bottom-[10px] z-30 hidden w-[232px] gap-2 rounded-xl bg-bg-1 p-3 sm:block"
            style={{
              boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
            }}>
            <Text className="text-fg-1" variant="body2">
              Join NOVA to access our network of creatives
            </Text>
            <Link href="/sign-up">
              <Button variant={"secondary"} className="mt-2 w-full" onClick={handleSignupClick}>
                Sign up for NOVA
              </Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  )
}
